export default function () {
  return {
    slider: null,
  };
}
